// src/lib/plMonthRange.ts (2026-09-26 — 経営PL タブで選べる対象月)
//
// [2026-09-26 ユーザ指示] 経営PL の対象月は「PL の実績がある月」 だけ選べる。
//   PL 帳票は病院 KPI (meta.dateMin/Max) と別に届くので、 範囲は PL 側の実績月で決める。
//   直近12ヶ月累計は 12 ヶ月そろう月から (それより前は累計が出せず全カードが空欄になる)。
//
// ★store の asOfMonth は書き換えず、 表示するときに範囲内へ寄せる (clampPlMonth)。
//   effect で書き換えると ?as= を明示した共有URL を潰す (check-url-override-guard.mjs が CI で止める)。
//   URL guard を付けると、 月を選んだ時点で URL に as= が載るため表示形式の切替で寄らなくなる。
import type { PlResponse } from "@shared/api";
import type { PlFormat } from "../store";

export type PlMonthRange = { min: string; max: string };   // "YYYY-MM"

export function plMonthRange(data: PlResponse | undefined, format: PlFormat): PlMonthRange | null {
  if (!data) return null;
  const yms = [...new Set([...data.budgetActual, ...data.monthly].map((r) => r.date.slice(0, 7)))].sort();
  if (yms.length === 0) return null;
  const max = yms[yms.length - 1];
  const min = format === "直近12ヶ月累計" ? (yms[11] ?? max) : yms[0];
  return { min, max };
}

// asOfMonth ("YYYY-MM-DD") を範囲内へ寄せて "YYYY-MM-01" で返す
export function clampPlMonth(asOfMonth: string, range: PlMonthRange | null): string {
  if (!range) return asOfMonth;
  const ym = asOfMonth.slice(0, 7);
  if (ym > range.max) return `${range.max}-01`;
  if (ym < range.min) return `${range.min}-01`;
  return asOfMonth;
}
